module.exports = __webpack_public_path__ + "assets/icon-transhipment-chat.38954ea1.svg";